module.exports = __webpack_public_path__ + "img/burgerBuilder2.fc0dfe92.png";